/*
 * @Descripttion:
 * @version:
 * @Author: loong
 * @Date: 2022-09-08 15:30:36
 * @LastEditors: loong
 * @LastEditTime: 2022-09-08 16:50:09
 */
// 通用顶部条组件
const topbar = () => import ("../../layout/topbar");
// 通用主体顶部组件
const AppHeader_Nav = () => import ("../../layout/AppHeader_Navs");
// 通用主体头部组件
const AppHeader_main = () => import ("../../layout/AppHeader_main");
// 通用底部组件
const AppFooter = () => import ("../../layout/AppFooter");
// 当前路由组件
const newsInfo = () => import('../../views/newsInfo/index');
const newsDetail = () => import('../../views/newsInfo/newsDetail.vue');
export default [{
  path: "/newsInfo",
  name: "newsInfo",
  components: {
    topbar: topbar,
    header: AppHeader_main,//AppHeader_Nav 顶部主体样式 || AppHeader_main 头部主体样式
    default: newsInfo,
    footer: AppFooter,
  },
  meta: {
    requireAuth: false // 需要验证登录状态
  },
  props: {
    header: {
      type: '1',//根据不同类型切入组件判断逻辑
    }
  },
}, {
  path: "/newsDetail",
  name: "newsDetail",
  components: {
    topbar: topbar,
    header: AppHeader_main,//AppHeader_Nav 顶部主体样式 || AppHeader_main 头部主体样式
    default: newsDetail,
    footer: AppFooter,
  },
  meta: {
    requireAuth: false // 需要验证登录状态
  },
  props: {
    header: {
      type: '1',//根据不同类型切入组件判断逻辑
    }
  },
}
]
